import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { DireccionRequest } from "../../domain/model/maestro/entity/direccion-request";
import { UbicacionGateway } from "../../domain/model/ubicacion/gateway/ubicacion-gateway";
import { CapaToken } from "../../infraestructure/response-model/geosura/capa-token.response";
import { Token } from "../../infraestructure/response-model/geosura/token.response";
import { GeoSuraParamsEnum } from "../../shared/utils/enums/geosura-params.enum";


@Injectable({
  providedIn: "root",
})
export class UbicacionService extends UbicacionGateway {
  private readonly geoSuraBaseUrl: string;
  private readonly url: string;
  private readonly port: string;

  constructor(private readonly httpClient: HttpClient) {
    super();
    this.geoSuraBaseUrl = environment.geoSuraBaseUrl;
    this.url = environment.apiBaseUrl;
    this.port = environment.portBaseUrl;
  }

  getTokenGeosura(address: DireccionRequest): Observable<Token> {
    const url = `${this.url}${this.port}/api_novedades/novedad/geosura/get-token`;
    const params = {
      city: address.city,
      address: address.address,
    };
    return this.httpClient.get<Token>(url, { params }).pipe();
  }

  getMapaGeosura(token: string): string {
    return `${this.geoSuraBaseUrl}/VISOR/mapa.jsp?aplicacion=${GeoSuraParamsEnum.APPLICATION_CODE}&token=${token}`;
  }

  getCoorsByToken(token: string): Observable<CapaToken> {
    const url = `${this.url}${this.port}/api_novedades/novedad/geosura/get-coors-by-token`;
    const params = { token };
    return this.httpClient.get<CapaToken>(url, { params }).pipe();
  }
}
